/** @jsx jsx */
import { jsx } from 'theme-ui';
// import BaseRegion from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductRegion';

export * from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductRegion';

export default function ProductRegion({ product, ...rest }) {
  return null;
}
